<!--
 * @Description:
 * @Version: 2.5.2
 * @Autor: jzt
 * @Date: 2023-03-15 10:00:00
 * @LastEditors: jzt
 * @LastEditTime: 2023-03-16 17:00:00
-->
<template>
	<div v-loading="true" class="h100"></div>
</template>

<script>
import Vue from 'vue'
import Casdoor from 'casdoor-vue-sdk'
const config = {
	serverUrl: process.env.VUE_APP_LOGINPATH_URL,
  clientId: "fb08365db2bc320a3ba3",					// 客户端 Id
  organizationName: "built-in",							// 应用程序名称
  appName: "zscloud",												// 组织名称
  redirectPath: '/getToken',								// 重定向路径
};
// 进入登录页面转注册页  注册完成回登录页
// if(location.search) {
//   let urlArr = location.search.split('?')[1].split('&')
//   let searchObj = {}
//   urlArr.forEach(ele => {
//     let t = ele.split('=')
//     searchObj[t[0]] = t[1]
//   })
//   if(searchObj.share_code) {
//     config.redirectPath = '/getToken?share_code='+searchObj.share_code
//   }
// }
Vue.use(Casdoor,config)

export default {
	name: 'loginIndex',
	data() {
		return {}
	},
	created() {
		this.login()
	},
	methods: {
		login() {
			window.location.href = this.getSigninUrl();
		},
		signup() {
			window.location.href = this.getSignupUrl();
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/page/login/loginIndex.vue